import type { SVGProps } from "react";

const SvgStarOutlineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.5244 3.08203C11.6741 2.62137 12.3259 2.62138 12.4756 3.08203L13.9941 7.75488C14.195 8.37292 14.7711 8.79199 15.4209 8.79199H20.335C20.8193 8.79199 21.0207 9.41158 20.6289 9.69629L16.6533 12.585C16.1276 12.9669 15.9077 13.6437 16.1084 14.2617L17.627 18.9355C17.7766 19.3961 17.2493 19.7795 16.8574 19.4951L12.8818 16.6064C12.3561 16.2245 11.6439 16.2245 11.1182 16.6064L7.14258 19.4951C6.75074 19.7795 6.2234 19.3961 6.37305 18.9355L7.8916 14.2617C8.09235 13.6437 7.87238 12.9669 7.34668 12.585L3.37109 9.69629C2.97926 9.41158 3.18069 8.79199 3.66504 8.79199H8.5791C9.22894 8.79199 9.80505 8.37292 10.0059 7.75488L11.5244 3.08203Z"
        stroke="#B12F7B"
      />
    </svg>
  );
};
export default SvgStarOutlineIcon;
